import axios from "axios"

export default async function connectDatabase(db_data) {
    const res = await axios.post("/admin-dashboard/register-customer-db", db_data);
    return res.data
}